import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Erro no escopo do sistema: faixa plum de largura total abaixo do cabeçalho, com a hora do início
 * e o caminho alternativo. Some sozinha quando o serviço voltar.
 * Ex.: "Envio por WhatsApp indisponível — Instabilidade no provedor desde 09:20. Os envios ficam em fila…"
 */
export interface SystemBannerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
}

export function SystemBanner({
  title,
  description,
  action,
  className,
  ...props
}: SystemBannerProps) {
  return (
    <div
      data-slot="system-banner"
      role="status"
      className={cn(
        'bg-plum text-pampas max-desk:px-4 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 px-7 py-3',
        className,
      )}
      {...props}
    >
      <div className="font-body text-body leading-[1.5] font-light">
        <span className="font-display font-normal">{title}</span>
        {description ? <span className="text-pampas/80"> — {description}</span> : null}
      </div>
      {action}
    </div>
  )
}
